import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../utils/AuthContext';
import { useNavigate } from 'react-router-dom';

const Result = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!auth || !auth.userId) {
      setError('User authentication is required.');
      setLoading(false);
      navigate('/login'); // Redirect to login page if not authenticated
      return;
    }

    const fetchResults = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Exam/results/${auth.userId}`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });
        setResults(response.data.$values || response.data);
      } catch (error) {
        console.error('Error fetching results:', error);
        setError('Error fetching results');
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [auth, navigate]);

  if (loading) {
    return <div>Loading...</div>; // Show loading message while fetching data
  }

  if (error) {
    return <div>{error}</div>; // Show error message if there is an error
  }

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Exam Results</h2>
      {results.length > 0 ? (
        <table className="min-w-full leading-normal">
          <thead>
            <tr>
              <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Paper Set Title
              </th>
              <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Score
              </th>
              <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Exam Date
              </th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <tr key={index}>
                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  {result.paperSetTitle}
                </td>
                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  {result.correctResponses} / {result.totalResponses}
                </td>
                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  {new Date(result.examDate).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No results available.</p>
      )}
    </div>
  );
};

export default Result;
